export default class AuthorizeConsentRequest {
    constructor(public clientId: string, public responseType: string, public consented: boolean, public redirectUri?: string) {
    }
}
